import React from 'react';
import { BiErrorCircle } from 'react-icons/bi';
import { FlexProps, Icon, Text, Button } from '@chakra-ui/react';
import { Card } from './Card';

interface ErrorCard extends FlexProps {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  refetch: any;
}

export const ErrorCard: React.FC<ErrorCard> = ({ refetch, ...rest }) => {
  return (
    <Card {...rest} align="center">
      <Icon as={BiErrorCircle} color="negative" h="75px" w="75px" />
      <Text color="negative" fontSize="16px">
        Algo deu errado!
      </Text>
      <Button onClick={() => refetch()}>
        <Text>Tentar novamente</Text>
      </Button>
    </Card>
  );
};
